export default __webpack_public_path__ + "static/media/smoke-detector-icon.0afd2da6.svg";